import { SliderComponent } from '@webentorCore/_slider';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-team-slider-slider').forEach((element) => {
    // Parse data-slider attribute to get params
    const params = JSON.parse(element.getAttribute('data-slider') || '{}');

    params.on = {
      slideChange: (swiper) => {
        const activeSlideIndex = swiper.realIndex;

        // Hide all other slides content
        element
          .closest('.js-team-slider')
          .querySelectorAll('.js-team-slider-content')
          .forEach((slide) => {
            slide.classList.remove('slide-active');
          });

        // Show active slide content
        const activeSlideContent = element
          .closest('.js-team-slider')
          .querySelector(
            `.js-team-slider-content[data-slide-index="${activeSlideIndex}"]`,
          );

        activeSlideContent?.classList.add('slide-active');
      },
    };

    new SliderComponent(element, params);
  });
});
